import React, { Component } from 'react'
import styled from 'styled-components'
import Transition from 'react-transition-group/Transition'

const Container = styled.div`
  width: 100%;
  position: fixed;
  z-index: 3;
  bottom: 0;
  left: 0;
  padding: 40px 4vw;
  text-align: right;
  font-size: 12px;
  color: #4F4F4F;
  opacity: 0.8;
  transition: opacity .6s ease, transform .6s ease;
  opacity: 0;
  transform: translateX(20px);

  @media(max-width: 680px) {
    text-align: left;
    padding: 50px 10vw;
    position: relative;
  }

  a {
    color: #000000;
    text-decoration: none;
    transition: .3s ease;
    display: inline-flex;
    position: relative;
    overflow: hidden;

    &:before {
      position: absolute;
      content: '';
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: #000000;
      transform:  translateX(-110%);
      transition: transform .3s ease;
    }

    &:hover:before {
      transform: translateX(0);
    }

    @media(max-width: 680px) {
      color: #FFFFFF;
    }
  }
`

const transitionStyles = {
  entered:  {
    opacity: 1,
    transform: 'translateX(0)'
  },
}

class Footer extends Component {
  render () {
    return (
      <Transition in={this.props.loaded} timeout={1400}>
        {(state) => (
          <Container style={{...transitionStyles[state]}}>
          <span role="img" aria-label='br-flag'>🇧🇷</span> created in Brazil by <a href="https://edkf.com.br/" target="_blank" rel="noopener noreferrer">@edkf</a>
          </Container>
        )}
      </Transition>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.jsx